<template>
	<div class="wearth" ref="ragRef">
		<div class="mid_left_table_nav">
			<table class="mid_left_table" v-if="isshow">
				<tr>
					<th>操作时间</th>
					<th>操作名称</th>
					<th>操作方式</th>
					<th>操作人员</th>
				</tr>
				<tr v-for="item in datapages">
					<td>{{ item?.createDate }}</td>
					<td>{{ item?.fertilizerName}}</td>
					<td>{{ item?.useFertilizer}}</td>
					<td>{{ item?.operator}}</td>
				</tr>
			</table>
			<div class="mid_left_table_not" v-if="!isshow">
				<div class="mid_left_table_not_img">
					<img src="@/assets/model/null.png" alt="" />
				</div>
				<p>暂无水肥数据表数据</p>
			</div>


		</div>
		<div class="pagination">
			<pagination :initPageIndex="total" @changePage="handlePageChange" />
		</div>
	</div>
</template>
<script setup>
	import pagination from '../../pagination/index.vue';
	import {
		ElLoading
	} from 'element-plus'

	import {
		ref,
		onMounted,
		onUnmounted
	} from 'vue';
	import {
		GetWateringFertilizationTables
	} from '@/api/api.js'

	const datapages = ref([])
	const total = ref(0)
	const currentDate = new Date();
	//定义div的ref
	let ragRef = ref()
	let ragRefInstance = ref()

	let isshow = ref(true)

	onMounted(() => {
		ragRefInstance.value = ElLoading.service({
			target: ragRef.value,
			body: true,
			text: 'Loading...',
		})
		GetWateringFertilizationTables(1).then(res => {
			// 创建去年12月10日的日期对象
			var lastYearDate = new Date(currentDate.getFullYear() ,2, 31); // 月份是从0开始计数的，所以11表示12月

			// 创建今年1月31日的日期对象
			var thisYearDate = new Date(currentDate.getFullYear(), 4, 10);// 月份是从0开始计数的，所以0表示1月


			for (let i = 0; i < res.data.length; i++) {
				const itemDate = new Date(res.data[i].createDate); // 将字符串转换为 Date 对象
				
				// 判断当前日期是否在去年12月10日到今年1月31日之间
				if (itemDate >= lastYearDate && itemDate  <= thisYearDate) {
					datapages.value.push(res.data[i])
				}	
			}
			
			if (datapages.value.length == 0) {
				isshow.value = false;
			} else {
				total.value = datapages.value.length
			}
			ragRefInstance.value.close()
		}).catch(err => {
			console.log(err)
			ragRefInstance.value.close()
		})
	})

	function handlePageChange(pageindex) {
		ragRefInstance.value = ElLoading.service({
			target: ragRef.value,
			body: true,
			text: 'Loading...',
		})
		datapages.value = [];
		GetWateringFertilizationTables(1).then(res => {
			for (let i = 0; i < res.data.length; i++) {
				// 判断当前日期是否在去年12月10日到今年1月31日之间
				if (currentDate >= lastYearDate && currentDate <= thisYearDate) {
					datapages.value.push(res.data.list[i])
				}

			}
			ragRefInstance.value.close()
		}).catch(err => {
			console.log(err)
			ragRefInstance.value.close()
		})
	}

	function GetDynamicValue(item, prefix, suffix) {
		const key = `${prefix}_${suffix}`;
		return item[key];
	}
</script>

<style scoped lang="scss">
	.wearth {
		height: 460px;
		width: 660px;
	}


	.mid_left_table_nav {
		height: 400px;
		width: 600px;
		border: #007e62 1px solid;
		margin: 0 auto;

		.mid_left_table_not {
			display: flex;
			flex-direction: column;
			justify-content: center;
			/* 上下居中 */
			align-items: center;
			/* 左右居中 */
			text-align: center;
			/* 文字居中 */
			height: 100%;
			/* 设置高度为父容器的高度 */
			color: #007e62;
			font-size: 18px;
		}

		.mid_left_table_not_img img {
			/* 如果需要对图片进行样式设置，也可以添加在这里 */
		}

	}

	.mid_left_table {
		width: 600px;
		border-collapse: collapse;

		background-color: #02372d;
		text-align: center;
		margin: 0 auto;


		th {
			border: 1px solid #007e62;
			height: 20px;
			padding: 8px;
			color: #22caa5;
		}


		td {
			height: 20px;
			padding: 8px;
			border: 1px solid #007e62;
			color: white;

		}
	}

	.pagination {
		width: 100%;

		.el-pagination {
			width: 100%;
			margin-left: 120px;
			margin-top: 20px;

			:deep(.btn-prev),
			:deep(.btn-next) {
				border: 1px solid #007e62;
				background-color: transparent;
				width: 20px;
				height: 20px;
				margin-right: 5px;
			}

			:deep(.el-icon-arrow-left:before,
				.el-icon-arrow-right:before) {
				color: #d5bfa1;
				font-size: 14px;
			}
		}

		:deep(.el-pagination.is-background .el-pager li) {
			border: 1px solid #007e62;
			background-color: transparent;
			color: #007e62;
			width: 20px;
			height: 20px;
			line-height: 20px;
			font-size: 14px;
			margin-right: 5px;
		}

		:deep(.el-pagination.is-background .el-pager li:active) {

			background-color: #007e62;
			color: #007e62;

		}

	}
</style>